// leaveTypesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LeaveType, LeaveTypesState } from './types'

const initialState: LeaveTypesState = {
    leaveTypes: [],
}

const leaveTypesSlice = createSlice({
    name: 'leaveTypes',
    initialState,
    reducers: {
        setLeaveTypes(state, action: PayloadAction<LeaveType[]>) {
            state.leaveTypes = action.payload
        },
        addLeaveType(state, action: PayloadAction<LeaveType>) {
            state.leaveTypes.push(action.payload)
        },
        updateLeaveType(state, action: PayloadAction<LeaveType>) {
            const index = state.leaveTypes.findIndex(
                (type) => type.id === action.payload.id
            )
            if (index !== -1) {
                state.leaveTypes[index] = action.payload
            }
        },
        deleteLeaveType(state, action: PayloadAction<string>) {
            state.leaveTypes = state.leaveTypes.filter(
                (type) => type.id !== action.payload
            )
        },
    },
})

export const { setLeaveTypes, addLeaveType, updateLeaveType, deleteLeaveType } =
    leaveTypesSlice.actions

export default leaveTypesSlice.reducer
